const getAllLocationData = `mutation 
(
  $companyId: BigInt!
  $userId: BigInt
) {
  getAllLocations(
    input: {
      _companyId: $companyId, 
      _userId: $userId}
  ) 
  {
    getAllLocationsJsons
  }
}`;

const getRegionHierarchyData = `mutation 
(
  $companyId: BigInt!, 
  $userId: BigInt
)
{
  getRegionHierarchy
  (
    input: 
    {
      _companyId: $companyId, 
      _userId: $userId
    }
  )
  {
    regHierJsons
  }
}`;

const getLocationHierarchyData = `mutation 
(
  $companyId: BigInt!, 
  $userId: BigInt
)
{
  getLocationHierarchy
  (
    input: 
    {
      _companyId: $companyId, 
      _userId: $userId
    }
  )
  {
    depsHierJsons
  }
}`;

const getLaneRebootData = `
mutation(
  $regionLocationId: [BigInt!]
  $fromDate: Date
  $toDate: Date
  $laneNum: [BigInt]
  $endTime: Time
  $startTime: Time
  $inTransaction: Boolean
  $isNonZero: Boolean
  $rebootCount: Int
) {
  getLaneRebootData(
    input: {
      _regionLocationId: $regionLocationId
      _startDate: $fromDate
      _endDate: $toDate
      _laneNum: $laneNum
      _endTime: $endTime
      _startTime: $startTime
      _inTransaction: $inTransaction
      _isNonZero: $isNonZero
      _rebootCount: $rebootCount
    }
  ) {
    laneRebootJsons
  }
}`;

const getLocationLane = `
 mutation(
        $locationIds: [BigInt!]
      )
      {
        locationLaneDropdown
        (input: 
          {_regionLocationIds: $locationIds}) 
        {
          laneDropdowns
        }
      }
   `;

const getLaneRebootDetails = `
 mutation(
  $regionLocationId: BigInt
  $businessDate: Date
  $laneNum: Int
  $inTransaction: Boolean
  $endTime: Time
  $startTime: Time
) {
  getLaneRebootDetails(
    input: {
      _regionLocationId: $regionLocationId
      _laneNum: $laneNum
      _inTransaction: $inTransaction
      _businessDate: $businessDate
      _endTime: $endTime
      _startTime: $startTime
    }
  ) {
    laneRebootDetailsJsons
  }
}`;
export { getAllLocationData, getLocationHierarchyData, getRegionHierarchyData, getLaneRebootData, getLocationLane, getLaneRebootDetails };